import * as React from 'react';

type StepProgressProps = {
  activeIndex: number;
  data: string[];
  label?: string;
};

const StepProgress = ({
  data,
  activeIndex,
  label = "Progress",
  ...props
}: StepProgressProps) => {
  const maxIndex = Math.max(data.length - 1, 0);
  const clampedIndex = Math.min(Math.max(activeIndex, 0), maxIndex);
  const progress =
    data.length <= 1 ? 100 : Math.round((clampedIndex / maxIndex) * 100);
  const currentStepLabel = data[clampedIndex];

  return (
    <nav className="step-progress" aria-label={label}>
      <ol className="align-items-end d-flex justify-content-between steps">
        {data.map((e, index) => {
          return (
            <li
              key={`step-${index}`}
              className={`poppins${index <= clampedIndex ? " done" : ""}${
                index == clampedIndex ? " active" : ""
              }`}
              aria-current={index === clampedIndex ? "step" : undefined}
            >
              {e}
            </li>
          );
        })}
      </ol>
      <div className="progress">
        <div
          className="progress-bar"
          role="progressbar"
          aria-label={label}
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuetext={
            currentStepLabel
              ? `Step ${clampedIndex + 1} of ${data.length}: ${currentStepLabel}`
              : undefined
          }
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </nav>
  );
};

export default StepProgress;
